import { Controller } from "@hotwired/stimulus"

// Máscara de moeda pt-BR.
// O input visível ("display") mostra 877.790.898,98;
// o hidden field carrega o valor numérico (877790898.98) enviado no submit.
// Digitação tratada como centavos (estilo caixa registradora).
export default class extends Controller {
  static targets = ["display", "hidden"]

  connect() {
    this.render(this.parse(this.hiddenTarget.value))
  }

  onInput() {
    const cents = this.displayTarget.value.replace(/\D/g, "")

    if (cents === "") {
      this.hiddenTarget.value = ""
      this.displayTarget.value = ""
      return
    }

    const value = parseInt(cents, 10) / 100
    this.hiddenTarget.value = value.toFixed(2)
    this.displayTarget.value = this.formatBR(value)
  }

  parse(raw) {
    if (raw === null || raw === undefined || raw === "") return null
    const n = parseFloat(raw)
    return isNaN(n) ? null : n
  }

  render(value) {
    this.displayTarget.value = value === null ? "" : this.formatBR(value)
  }

  formatBR(value) {
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
